<template>
  <v-dialog v-model="returnDialog" class="the-app-dialogs" persistent max-width="1300px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Return Purchase') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="title no-select pb-1">
              <v-layout>{{ $t('Purchase Information') }}</v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap justify-content-end>
                  <v-flex xs4 class="pb-3">
                    <div class="caption no-select">{{ $t('Bill Number') }}</div>
                    <strong>{{ purchaseData.bill_auto_number || '-' }}</strong>
                  </v-flex>
                  <v-flex xs4 class="pb-3">
                    <div class="caption no-select">
                      {{ $t('Supplier Invoice Number') }}
                    </div>
                    <strong>{{ purchaseData.supplier_invoice_number || '-' }}</strong>
                  </v-flex>
                  <v-flex xs4 class="pb-3">
                    <div class="caption no-select">
                      {{ $t('Supplier Number') }}
                    </div>
                    <strong>{{ purchaseData.vendor_name || '-' }}</strong>
                  </v-flex>
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">{{ $t('Bill Date') }}</div>
                    <strong>{{ purchaseData.bill_date || '-' }}</strong>
                  </v-flex>
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">
                      {{ `${$t('Total Amount')} (${systemCurrency})` }}
                    </div>
                    <strong>{{ purchaseData.total_amount | currency }}</strong>
                  </v-flex>
                  <!-- <v-flex xs3 class="pb-3">
                    <div class="caption no-select">{{ `${$t('Net Amount')} (${systemCurrency})` }}</div>
                    <strong>{{ purchaseData.net_amount | currency }}</strong>
                  </v-flex>-->
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">{{ $t('Discount') }}</div>
                    <strong>{{ purchaseData.discount | percentage }}</strong>
                  </v-flex>

                  <v-flex xs12 class="title no-select pb-1">
                    <hr style="margin: 10px 0px" />
                    <v-layout>{{ $t('Return Purchase Information') }}</v-layout>
                  </v-flex>

                  <v-flex xs4 sm4 class="pa-2">
                    <v-menu v-model="returnDateMenu" full-width max-width="290" :close-on-content-click="false">
                      <v-text-field
                        slot="activator"
                        :value="returnForm.return_date"
                        :label="`${$t('Return Date')} *`"
                        prepend-inner-icon="event"
                        box
                        readonly
                        hide-details
                        name="return_date"
                        background-color="white"
                        autocomplete="off"
                        :error="errors.has('return_date')"
                        v-validate="'required|date_format:yyyy-MM-dd'"
                      />
                      <v-date-picker @change="returnDateMenu = false" v-model="returnForm.return_date" />
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 style="margin-top: 20px">
                <v-layout row wrap class="form-table-header">
                  <v-flex class="form-table-content">
                    <v-layout row>
                      <v-flex xs2 pa-2>#</v-flex>
                      <v-flex xs10 pa-2>{{ $t('Product') }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs8 class="form-table-content">
                    <v-layout row>
                      <v-flex pa-2 v-if="hasCollection">{{ $t('Collections') }}</v-flex>
                      <v-flex pa-2>{{ $t('Purchased Quantity') }}</v-flex>
                      <v-flex pa-2>{{ $t('Available Quantity') }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Purchase Price')} (${systemCurrency})` }}</v-flex>
                      <v-flex pa-2>{{ $t('Returned Quantity') }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Return Price')} (${systemCurrency})` }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Total')} (${systemCurrency})` }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('Action') }}</v-flex>
                </v-layout>

                <template v-if="rowNumbers > 0">
                  <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                    <v-flex>
                      <v-layout row>
                        <v-flex xs2 class="pa-1" style="text-align: center; margin-top: 20px; font-size: 16px">{{
                          index + 1
                        }}</v-flex>
                        <v-flex xs10 class="pa-1">
                          <v-text-field
                            v-model="returnForm.product_name[index]"
                            :label="`${$t('Product')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Product' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Product' + (index + 1))"
                            v-validate="'required'"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs8>
                      <v-layout row>
                        <v-flex pa-1 v-if="hasCollection">
                          <v-text-field
                            v-model.number="returnForm.collection_name[index]"
                            :label="$t('Collections')"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'collections' + (index + 1)"
                            background-color="white"
                            :error="errors.has('collections' + (index + 1))"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="returnForm.purchase_quantity[index]"
                            :label="`${$t('Purchase Quantity')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Purchase Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Purchase Quantity' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="returnForm.available_quantity[index]"
                            :label="`${$t('Available Quantity')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Available Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Available Quantity' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="returnForm.purchase_price[index]"
                            :label="`${$t('Purchase Price')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Purchase Price' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Purchase Price' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="returnForm.return_quantity[index]"
                            :label="`${$t('Return Quantity')} *`"
                            hide-details
                            box
                            :data-vv-name="'Return Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Return Quantity' + (index + 1))"
                            v-validate="'required|decimal:3|between:1,' + returnForm.purchase_quantity[index]"
                            @input="
                              calculateTotal(index, returnForm.return_quantity[index], returnForm.return_price[index])
                            "
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="returnForm.return_price[index]"
                            :label="`${$t('Return Price')} *`"
                            hide-details
                            box
                            :data-vv-name="'Return Price' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Return Price' + (index + 1))"
                            v-validate="'required|decimal:3|min_value:0'"
                            @input="
                              calculateTotal(index, returnForm.return_quantity[index], returnForm.return_price[index])
                            "
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="returnForm.total[index]"
                            :label="`${$t('Total')} *`"
                            hide-details
                            box
                            readonly
                            background-color="white"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs1 class="pa-3" style="text-align: center">
                      <v-tooltip top>
                        <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Remove this row') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :disabled="rowNumbers < 1" :loading="btnReturnLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Return') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'return-component',

  props: {
    returnDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnReturnLoading: false,
      returnDateMenu: false,
      rowNumbers: 0,
      purchaseData: {
        bill_auto_number: '',
        supplier_invoice_number: '',
        bill_date: '',
        total_amount: '',
        net_amount: '',
        discount: '',
        vendor_name: ''
      },
      returnForm: {
        purchase_id: 0,
        return_date: '',
        product_id_fk: [],
        product_name: [],
        collection_id_fk: [],
        collection_name: [],
        collection_quantity: [],
        purchase_detail_id_fk: [],
        purchase_quantity: [],
        available_quantity: [],
        return_quantity: [],
        purchase_price: [],
        return_price: [],
        total: []
      }
    }
  },

  computed: {
    ...mapGetters({
      purchaseInfo: 'purchases/getPurchaseInfo',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    returnDialog: {
      immediate: false,
      handler() {
        if (this.returnDialog) {
          this.rowNumbers = this.purchaseInfo.data_detail.length
          this.purchaseData.supplier_invoice_number = this.purchaseInfo.data.supplier_invoice_number
          this.purchaseData.bill_auto_number = this.purchaseInfo.data.bill_auto_number
          this.purchaseData.bill_date = this.purchaseInfo.data.bill_date
          this.purchaseData.total_amount = this.purchaseInfo.data.total_amount
          this.purchaseData.net_amount = this.purchaseInfo.data.net_amount
          this.purchaseData.discount = this.purchaseInfo.data.discount
          this.purchaseData.vendor_name = this.purchaseInfo.data.vender_name
          this.returnForm.purchase_id = Number(this.purchaseInfo.data.purchase_id)

          this.returnForm.product_id_fk = []
          this.returnForm.product_name = []
          this.returnForm.collection_id_fk = []
          this.returnForm.collection_name = []
          this.returnForm.collection_quantity = []
          this.returnForm.purchase_detail_id_fk = []
          this.returnForm.purchase_quantity = []
          this.returnForm.available_quantity = []
          this.returnForm.return_quantity = []
          this.returnForm.purchase_price = []
          this.returnForm.return_price = []
          this.returnForm.total = []
          this.returnForm.return_date = this.$moment()
            .format()
            .substr(0, 10)

          this.purchaseInfo.data_detail.forEach((c, index) => {
            this.returnForm.product_id_fk.push(c.product_id_fk)
            this.returnForm.product_name.push(c.product_name)
            this.returnForm.collection_id_fk.push(c.collection_id_fk)
            this.returnForm.collection_name.push(c.collection_name)
            this.returnForm.collection_quantity.push(c.collection_quantity)
            if (this.returnForm.collection_name[index]) {
              this.returnForm.purchase_quantity.push(c.purchase_collection_quantity)
              this.returnForm.available_quantity.push((c.available_quantity / c.collection_quantity).toFixed(2))
              this.returnForm.purchase_price.push(c.purchase_collection_price)
              this.returnForm.return_price.push(c.purchase_collection_price)
            } else {
              this.returnForm.purchase_quantity.push(c.purchase_quantity)
              this.returnForm.available_quantity.push(c.available_quantity)
              this.returnForm.purchase_price.push(c.purchase_price)
              this.returnForm.return_price.push(c.purchase_price)
            }
            this.returnForm.purchase_detail_id_fk.push(c.purchase_detail_id)
          })

          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      returnPurchase: 'purchasesReturns/addPurchaseReturn'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.returnDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.returnForm.product_id_fk.splice(index, 1)
      this.returnForm.product_name.splice(index, 1)
      this.returnForm.collection_id_fk.splice(index, 1)
      this.returnForm.collection_name.splice(index, 1)
      this.returnForm.collection_quantity.splice(index, 1)
      this.returnForm.purchase_detail_id_fk.splice(index, 1)
      this.returnForm.purchase_quantity.splice(index, 1)
      this.returnForm.available_quantity.splice(index, 1)
      this.returnForm.return_quantity.splice(index, 1)
      this.returnForm.purchase_price.splice(index, 1)
      this.returnForm.return_price.splice(index, 1)
      this.returnForm.total.splice(index, 1)
    },

    calculateTotal(index, quantity, thePrice) {
      let qtt = 0
      let price = 0
      let sumPrice = 0

      if (!isNaN(quantity)) {
        qtt = quantity
      }
      if (!isNaN(thePrice)) {
        price = thePrice
      }

      sumPrice = qtt * price
      sumPrice = Number(sumPrice)
      this.returnForm.total[index] = sumPrice.toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnReturnLoading = true
            let formData = new FormData(event.target)
            formData.append('purchase_id_fk', this.returnForm.purchase_id)

            this.returnForm.product_id_fk.forEach((p, index) => {
              formData.append('product_id_fk[' + [index] + ']', p)
              formData.append('collection_id_fk[' + [index] + ']', this.returnForm.collection_id_fk[index] || '')
              if (this.returnForm.collection_id_fk[index]) {
                formData.append('return_collection_quantity[' + index + ']', this.returnForm.return_quantity[index])
                formData.append('return_collection_price[' + index + ']', this.returnForm.return_price[index])
                formData.append(
                  'return_quantity[' + index + ']',
                  (this.returnForm.return_quantity[index] * this.returnForm.collection_quantity[index]).toFixed(2)
                )
                formData.append(
                  'return_price[' + index + ']',
                  (this.returnForm.return_price[index] / this.returnForm.collection_quantity[index]).toFixed(2)
                )
              } else {
                formData.append('return_collection_quantity[' + index + ']', '')
                formData.append('return_collection_price[' + index + ']', '')
                formData.append('return_quantity[' + index + ']', this.returnForm.return_quantity[index])
                formData.append('return_price[' + index + ']', this.returnForm.return_price[index])
              }
            })

            this.returnForm.purchase_detail_id_fk.forEach((p, index) => {
              formData.append('purchase_detail_id_fk[' + [index] + ']', p)
            })

            this.returnPurchase(formData)
              .then(() => {
                this.btnReturnLoading = false
                this.$emit('returned')
              })
              .catch(() => {
                this.btnReturnLoading = false
              })
          }
        })
        .catch(() => {
          this.btnReturnLoading = false
        })
    }
  }
}
</script>

<style scoped />
